import { useContext, useMemo } from 'react';
import { LocationFormContext } from '../../../context';
import { MANEUVER_ZOOM } from '../const';
import { EditMapManeuvers } from './EditMapManeuvers';
import { BaseMap } from 'components/maps';
import { Position } from 'types';

export const ManeuversMap = () => {
  const { values } = useContext(LocationFormContext);

  const viewState = useMemo(() => {
    const coordinates = values?.geometry?.coordinates as Position;

    return coordinates
      ? {
          longitude: coordinates[0],
          latitude: coordinates[1],
          zoom: MANEUVER_ZOOM,
        }
      : undefined;
  }, [values?.geometry?.coordinates]);

  return (
    <BaseMap viewState={viewState}>
      <EditMapManeuvers />
    </BaseMap>
  );
};
